import {
  TelemetryDataProvider,
  telemetryDataProviderSchema,
} from "@qivia/schemas-cards-vehicles";
import { VehiclesListType } from "./vehiclesAPI";

export type VehicleConnectionType = "TELEMATICS" | "DEVICE";

const dataProviders = telemetryDataProviderSchema.unwrap().enum;

export const DATA_PROVIDER_BY_CONNECTION_TYPE: Record<
  VehicleConnectionType,
  NonNullable<TelemetryDataProvider>
> = {
  TELEMATICS: dataProviders.HIGH_MOBILITY,
  DEVICE: dataProviders.FLESPI,
};

export const findVehicleConnectionType = (
  vehicle: VehiclesListType,
): VehicleConnectionType => (vehicle.isEligible ? "TELEMATICS" : "DEVICE");
